// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2VVMk","obliqueLineWrap":"membershipbadge_obliqueLineWrap__M7xaj","obliqueLine":"membershipbadge_obliqueLine__13imo"};